import { CreateAccountSchema, GuestLoginWithOtpSchema } from '@/lib/schemas/guestAuth'
import { ParseCompanyUrlResponse } from '@/lib/types/CompanyT'
import { postRequest, uploadRequest } from '@/lib/request'

export const guestSignIn = async (data: GuestLoginWithOtpSchema) => {
  return postRequest('/admin/login', data, {
    showToast: true,
    successMessage: 'Verification code sent to your email.',
    pendingMessage: 'Sending verification code...',
    errorMessage: 'Failed to send code. Please check your details and try again',
    customErrorMessages: {
      401: 'Incorrect password. Please try again',
    },
  })
}

export const verifyGuestOtp = async (
  data: Omit<GuestLoginWithOtpSchema, 'password'>
): Promise<{ token: string }> => {
  return postRequest('/admin/confirm-login', data, {
    showToast: true,
    successMessage: 'Welcome back! You’re now signed in.',
    pendingMessage: 'Signing you in...',
    errorMessage: 'Invalid or expired code. Please try again.',
  })
}

export const resendGuestOtp = async (data: GuestLoginWithOtpSchema) => {
  return postRequest('/admin/login', data, {
    showToast: true,
    successMessage: 'A new verification code has been sent to your email.',
    pendingMessage: 'Resending code...',
    errorMessage: 'Failed to resend code. Please try again.',
  })
}

export const registrationCompany = (params: CreateAccountSchema) => {
  return postRequest('/companies/register', params, {
    showToast: true,
    successMessage: 'Please check your email to verify your account.',
    pendingMessage: 'Sending verification code...',
    errorMessage: 'Registration failed. Please check your details and try again.',
    customErrorMessagesByCode: {
      10008: 'A user with this email already exists. Please use another email.',
    },
  })
}

export const confirmRegistrationCompany = (
  params: CreateAccountSchema & {
    vcard: Partial<Omit<ParseCompanyUrlResponse, 'avatar'> & { avatar: File | undefined }>
  }
): Promise<{ token: string; vcardId: number }> => {
  return uploadRequest('/companies/confirm-registration', 'POST', params, {
    showToast: true,
    successMessage: 'Registration successful!',
    pendingMessage: 'Confirming your registration...',
    errorMessage: 'Invalid or expired code. Please try again.',
  })
}
